import React from 'react';
import './CameraNumber.css';

// ТЗ V5 №10: только настоящий целый id из ответа — без индекса строки и без заглушек.
export const isValidCameraId = (id) => Number.isSafeInteger(id) && id > 0;

/**
 * Номер камеры серым после имени: «C110 #134». Нет валидного id — ничего не
 * рисуется, ложный номер хуже отсутствующего.
 */
const CameraNumber = ({ id, className = '' }) => {
  if (!isValidCameraId(id)) return null;
  return (
    <span className={`cam-number ${className}`.trim()} title="Номер камеры">
      #{id}
    </span>
  );
};

export default CameraNumber;
